import type { Element } from 'react'
import React, { Fragment } from 'react'
import styled from 'styled-components'
import { SmallText } from 'app/common/typography'
import { EmptyCircle, RadioChecked } from 'app/assets/icons'
import { colors } from 'shared/assets/styles'
import { FormattedMessage } from 'react-intl'

type Props = {
    name?: string,
    label?: string,
    labelKey?: string,
    checked: boolean,
    onClick?: () => void,
    children?: Element<any>,
    TextStyle?: any,
    color?: string,
    noMargin?: boolean,
    disabled?: boolean
}

export const Radio = ({
    label,
    labelKey,
    checked,
    onClick,
    children,
    color,
    noMargin,
    TextStyle = SmallText,
    disabled
}: Props) => {
    return (
        <Clickable
            onClick={disabled ? undefined : onClick}
            disabled={!onClick || disabled}
            noMargin={noMargin}>
            <Fragment>
                {checked ? (
                    <RadioChecked color={color} />
                ) : (
                    <EmptyCircle color={color} />
                )}
            </Fragment>
            {children}
            {label ? (
                <LabelContainer>
                    <TextStyle>{label}</TextStyle>
                </LabelContainer>
            ) : (
                <Fragment>
                    {labelKey && (
                        <LabelContainer>
                            <FormattedMessage id={labelKey}>
                                {(text: string) => (
                                    <TextStyle color={colors.grey}>
                                        {text}
                                    </TextStyle>
                                )}
                            </FormattedMessage>
                        </LabelContainer>
                    )}
                </Fragment>
            )}
        </Clickable>
    )
}

const Clickable = styled.div`
    ${props => !props.disabled && 'cursor: pointer;'};
    display: flex;
    flex-direction: row;
    align-items: center;
    width: auto;
    justify-content: flex-start;
    ${props =>
        !props.noMargin &&
        `
        margin-left: 15px;
        margin-top: 5px;
    `};
    margin-bottom: 5px;
`

const LabelContainer = styled.div`
    padding-left: 5px;
    max-width: calc(100% - 29px);
`
